import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconMoveVert = props => (
  <SvgIcon {...props} viewBox="0 0 10.0001 15.99996">
    <path d="m8 12c1.1046 0 2 0.89543 2 2s-0.89543 2-2 2-2-0.89543-2-2 0.89543-2 2-2zm-6 0c1.1046 0 2 0.89543 2 2s-0.89543 2-2 2-2-0.89543-2-2 0.89543-2 2-2zm6.0001-6c1.1046 0 2 0.8954 2 2s-0.89543 2-2 2-2-0.8954-2-2 0.8954-2 2-2zm-6 0c1.1046 0 2 0.8954 2 2s-0.8954 2-2 2-2-0.8954-2-2 0.8954-2 2-2zm6-6c1.1046 0 2 0.89543 2 2s-0.89543 2-2 2-2-0.8954-2-2 0.8954-2 2-2zm-6 0c1.1046 0 2 0.89543 2 2s-0.8954 2-2 2-2-0.8954-2-2 0.8954-2 2-2z" />
  </SvgIcon>
);

export default IconMoveVert;



// WEBPACK FOOTER //
// ./src/components/icons/IconMoveVert.js